import { useState } from 'react';
import { getAuthenticatedClient } from '../Utils/tokenHelper';
import { enableFrontdoor } from '../Utils/features';
import { useAccount, useMsal } from '@azure/msal-react';

const BASE_URL = enableFrontdoor ? process.env.REACT_APP_DATAACCESS_API_BASE_URL_FRONTDOOR : process.env.REACT_APP_DATAACCESS_API_BASE_URL;

export default function useDataAccessDownload() {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0]);

    const executeDownload = async (fileCategory, fileName) => {
        setLoading(true);
        setSuccess(false);
        setError(null);
        setResult(null);

        try {
            const { data } = await getAuthenticatedClient({
                url: `${BASE_URL}/dataaccess/${fileCategory}/${fileName}`,
                method: 'GET',
                responseType: 'blob',
                msalInstance: instance,
                account
            });

            setResult(data);
            setSuccess(true);
            return data;
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setLoading(false);
        setSuccess(false);
        setError(null);
        setResult(null);
    };

    return {
        loading,
        success,
        error,
        result,
        execute: executeDownload,
        reset
    };
}
